export default __webpack_public_path__ + "static/media/female-average.1faea2ac.webp";